import Vue from 'vue'
import Vuex from 'vuex'
import config from '@/config'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    featureNb: 0,
    categories: null,
    bins: null,
    sessionId: null,
    cartoLayer: [],
    statistics: config.statisticsVariables.reduce((acc, cur) => ({ ...acc, [cur.id]: null }), {}),
    date: [1559347200, 1559865600],
    place: 'Scotiabank Arena',
    dateRange: [1559347200, 1559865600]
  },
  mutations: {
    setFeatureNb (state, value) {
      state.featureNb = value
    },
    setCategories (state, value) {
      state.categories = value
    },
    setBins (state, value) {
      state.bins = value
    },
    setSessionId (state, value) {
      state.sessionId = value
    },
    setStatistics (state, data) {
      data.forEach(({ id, value }) => {
        state.statistics[id] = value
      })
    },
    setDate (state, value) {
      state.date = value
    },
    setPlace (state, value) {
      state.place = value
    },
    setDateRange (state, value) {
      state.dateRange = value
    }
  },
  getters: {
    population: state => state.population,
    houseCount: state => state.houseCount,
    incomeAvg: state => state.incomeAvg,
    incomeDist: state => state.statistics.incomeDist,
    statistics: state => state.statistics,
    customerCount: state => state.customerCount,
    orderSum: state => state.orderSum,
    spentSum: state => state.spentSum,
    ages: state => labels => Object.keys(state.statistics)
      .filter(key => key.indexOf('age') !== -1)
      .map(key =>
        ({ name: labels[key], value: state.statistics[key], color: '#FEC503' })
      ),
    revenuesCategories: state => labels => Object.keys(state.statistics)
      .filter(key => key.indexOf('revenu') !== -1)
      .map(key =>
        ({ name: labels[key], value: state.statistics[key], color: '#FEC503' })
      )
  }
})
